<template>
    <v-row
        no-gutters
        align="center"
    >
        <v-col class="shrink">
            <div
                v-if="matchedClientStatus === ImportResultModule.MATCHED_CLIENT_STATUS.ADD_NEW_MATCHED && matchedClientText"
                class="body-2 font-weight-medium"
                style="white-space: nowrap"
            >
                {{ matchedClientText }}
            </div>
            <v-chip
                v-else-if="matchedClientText"
                class="font-weight-medium"
                :color="matchedClientChipBackgroundColor"
                :class="matchedClientChipTextColor"
            >
                {{ matchedClientText }}
            </v-chip>
        </v-col>
    </v-row>
</template>

<script>
import { computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import Dialog from "@/components/Dialog.vue";
import RichDataTable from "@/components/RichDataTable/RichDataTable";
import ImportResultModule from "@/views/Import/Result/ImportResultModule";

export default {
    name: "ImportResultRow",
    components: {
        RichDataTable,
        Dialog,
    },
    props: {
        selectedImportClients: {
            type: Array,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const matchedClientStatus = computed(() => {
            return ImportResultModule.getMatchedClientStatus(
                props.selectedImportClients,
                props.item.import_client_id
            )
        })

        const matchedClientChipBackgroundColor = computed(() => {
            if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.ADD_NEW_UNMATCHED) {
                return 'tretiary darken-1'
            } else if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.ADD_NEW_MATCHED) {
                return 'main'
            } else if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.IGNORE) {
                return 'g2'
            }
        })

        const matchedClientChipTextColor = computed(() => {
            if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.IGNORE) {
                return 'g5--text'
            } else {
                return 'white--text'
            }
        })

        const matchedClientText = computed(() => {
            if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.IGNORE) {
                return null
            } else if (matchedClientStatus.value === ImportResultModule.MATCHED_CLIENT_STATUS.ADD_NEW_UNMATCHED) {
                return $t('NEW CLIENT')
            }

            return props.item.uku_client_name
        })

        return {
            matchedClientStatus,
            ImportResultModule,
            matchedClientChipTextColor,
            matchedClientChipBackgroundColor,
            matchedClientText
        };
    }
};
</script>

<style scoped lang="scss">
.v-chip {
    height: 24px !important;
}
</style>